import { ClickEvent, SplitterOrientation, TableSelectionEvent, Button, DataHeaderProps, DataSourceMode, CrudDecoratorCloseEvent } from "@mcleod/components";
import { ModelRow, Navigation } from "@mcleod/core";
import { AutogenLayoutCashReceiptsProcessing } from "./autogen/AutogenLayoutCashReceiptsProcessing";
import { ImageName } from "@mcleod/images";
export class CashReceiptsProcessing extends AutogenLayoutCashReceiptsProcessing {
    //

    onLoad(): void | Promise<void> {
        this.splitterReceipts.orientation = SplitterOrientation.VERTICAL;
        this.sourceDeposits.orderBy = [{ field: "id", sort: "asc" }];
        this.sourceCashReceipt.orderBy = [{ field: "batch_id", sort: "asc" }];
        this.tableCashReceipts.doOnRowDelete = async (_row) => {
            this.sourceDeposits.search();
        }
        this.tableDeposits.doOnRowDelete = async (_row) => {
            this.sourceCashReceipt.search();
        }

        this.tableDeposits.addRightTool(new Button({
                    id: "buttonAdd",
                    caption: "Add Deposit",
                    imageName: ImageName.add,
                    color: "primary",
                    hotkey: "Alt-A",
                    onClick: () => {
                        const url = "/" + this.tableDeposits.addLayout + "?mode=add";
                        const dataHeaderProps: Partial<DataHeaderProps> = {
                            onExecute: (addedRow: ModelRow) => {
                                if (!this.tableDeposits.dataSource.subscribeToChanges) {
                                    this.tableDeposits.dataSource.addRow(addedRow);
                                }
                            }
                        };
                        const decoratorProps = {
                            pseudoNavigateUrl: url
                        }
                        this.tableDeposits.crudManager.showCrud(DataSourceMode.ADD, decoratorProps, dataHeaderProps);
                    },
                    tooltip: "Add a new record",
                }));

        this.tableCashReceipts.addRightTool(new Button({
                    id: "buttonAdd",
                    caption: "Add Cash Receipt",
                    imageName: ImageName.add,
                    color: "primary",
                    hotkey: "Alt-A",
                    onClick: () => {
                        let url = "/" + this.tableCashReceipts.addLayout + "?mode=add";
                        if (this.tableDeposits.selectedRow) {
                            const id = this.tableDeposits.selectedRow.data.get("id");
                            url = url + `&deposit=${id}`;
                        }
                        const dataHeaderProps: Partial<DataHeaderProps> = {
                            onExecute: (addedRow: ModelRow) => {
                                if (!this.tableCashReceipts.dataSource.subscribeToChanges) {
                                    this.tableCashReceipts.dataSource.addRow(addedRow);
                                }
                            }
                        };
                        const decoratorProps = {
                            pseudoNavigateUrl: url
                        }
                        this.tableCashReceipts.crudManager.showCrud(DataSourceMode.ADD, decoratorProps, dataHeaderProps);
                    },
                    tooltip: "Add a new record",
                }));

        this.tableCashReceipts.addAfterCrudCloseListener((event: CrudDecoratorCloseEvent) => {
            this.sourceDeposits.search();
        });

        this.tableDeposits.addAfterCrudCloseListener((event: CrudDecoratorCloseEvent) => {
            this.sourceCashReceipt.search();
        });
    }


    /** This is an event handler for the onSelect event of tableDeposits. */
    tableDepositsOnSelect(event: TableSelectionEvent) {
        if (event.newRow) {
            const modelRow = event.newRow.data as ModelRow;
            if (!modelRow.isNull("id")) {
                this.tableCashReceipts.setFilter(modelRow.get("id"));
            }
        }
        else {
            this.tableCashReceipts.resetFilter();
        }
    }

    buttonImportOnClick(event: ClickEvent) {
        Navigation.navigateTo("lme/general/dataimport/FileImportProfileList?dataType=CR", { newTab: true });
    }
}



